import { useState } from "react";

import { ReadonlyDischarge } from "../../components/ReadonlyDischarge";

import { EditableDischarge } from "./components/EditableDischarge";
import { EditableDischargeV2 } from "./components/EditableDischargeV2";

import "./DischargeContent.styles.scss";

export function DischargeContent(props) {
  const { classes, dischargeValues, editable, setDischargeValues, version } = props;
  const [dischargeCount, setDischargeCount] = useState(1);
  const [dateIndex, setDateIndex] = useState(0);
  const [showDischargeDatePickers, setShowDischargeDatePickers] = useState([false]);

  const dischargeVersion = version ? version : "1";

  const renderDischargeContent = () => {
    if (editable) {
      const discharges = [];

      if (dischargeVersion === "1") {
        for (let i = 0; i < dischargeCount; i++) {
          discharges.push(
            <EditableDischarge
              classes={classes}
              dateIndex={dateIndex}
              dischargeCount={dischargeCount}
              dischargeValues={dischargeValues}
              index={i}
              key={i}
              setDateIndex={setDateIndex}
              setDischargeCount={setDischargeCount}
              setDischargeValues={setDischargeValues}
              setShowDischargeDatePickers={setShowDischargeDatePickers}
              showDischargeDatePickers={showDischargeDatePickers}
            />,
          );
        }
      } else {
        return (
          <EditableDischargeV2
            classes={classes}
            dateIndex={dateIndex}
            dischargeValues={dischargeValues}
            setDateIndex={setDateIndex}
            setDischargeValues={setDischargeValues}
            setShowDischargeDatePickers={setShowDischargeDatePickers}
            showDischargeDatePickers={showDischargeDatePickers}
          />
        );
      }

      return discharges;
    } else {
      return dischargeValues.map((discharge, index) => (
        <ReadonlyDischarge classes={classes} discharge={discharge} key={index} />
      ));
    }
  };

  return (
    <div className={classes && classes.card ? classes.card : null}>{renderDischargeContent()}</div>
  );
}
